import {ProductWrapper} from 'components/customer/Product';
import React from 'react';

/**
 * Room planner add-product panel.
 * @return {JSX.Element}
 */
export const ProductSelector = () => {
    return <ProductWrapper showTitle={false} />;
};
